import { gql } from '@apollo/client';

export const SEARCH_TOOL_INVENTORY_ORDER_FOR = gql`
  query SearchToolOrderInventoryByOrderedFor($userProjectId: String) {
    searchToolOrderInventoryByOrderedFor(userProjectId: $userProjectId) {
      items {
        id
        # dispatchQuantity will show as quantity for each item. but not for serialized items
        dispatchQuantity
        toolInventory {
          id
          # code displayed above description. If isSerialized=true show in yellow background
          barCode
          isSerialized
          description
          toolRoomId
          toolCatalogId
          toolCatalog {
            id
            bscnPartNumber
            name
            toolCatalogImageUrl
            toolCategory {
              id
              name
            }
          }
        }
        # this id will be needed for calling the checkIn mutation
        toolOrderCatalogId
      }
    }
  }
`;
